import { FC } from 'react';

import { formatNumber, formatNumberDecimals } from 'utils/formats';

import { HistoryMovement } from 'types';
import { RowCell } from 'modules/_shared/Table/types/RowCell';
import TableRow from 'modules/_shared/Table/components/TableRow';

type DefaultTableRowProps = {
  movement: HistoryMovement;
  index: number;
};

const DefaultTableRow: FC<DefaultTableRowProps> = ({ movement, index }) => {
  const cells = [
    {
      key: `movement-partner-${index}`,
      content: movement.partnerNameSeller,
      textPosition: 'left',
    },
    {
      key: `movement-class-${index}`,
      content: movement.holdingClassName,
      textPosition: 'left',
    },
    {
      key: `movement-price-${index}`,
      content: formatNumberDecimals(movement.sharePrice),
      textPosition: 'right',
    },
    {
      key: `movement-from-${index}`,
      content: formatNumber(movement.from),
      textPosition: 'right',
    },
    {
      key: `movement-to-${index}`,
      content: formatNumber(movement.to),
      textPosition: 'right',
    },

    {
      key: `movement-action-${index}`,
      content: '',
      textPosition: 'right',
    },
  ] as RowCell[];

  return <TableRow cells={cells} />;
};

export default DefaultTableRow;
